import { thrivePassApi } from "../../api/thrivePassApi";

export const thrivePassApiMap = () => thrivePassApi;


